import React from "react";
import GameDescription from "../presentational/GameDescription";
import TangibleDescription from "../presentational/TangibleDescription";
import VideoPresentation from "../presentational/VideoPresentation";

const videos = [
  {
    videoLink: "https://www.youtube.com/embed/Wx07I1GubQ0",
    title: "Final Video",
    description:
      "This video was used to give a quick overview of the entire project before doing a live demonstration of the game for our peers and invited guests. ",
    dateStamp: "16th Dec 2020",
  },

  {
    videoLink: "https://www.youtube.com/embed/IA8vOI88a70",
    title: "Last Agile Meeting",
    description:
      "This is the final update video where we cover our recent additions and changes and why they were needed. As usual we also talk about our future plans and problems we had encountered.",
    dateStamp: "23rd Nov 2020",
  },
  {
    videoLink: "https://www.youtube.com/embed/nvn_oN0xuBU",
    title: "Third Agile Meeting",
    description:
      "Another update video where we cover our progress since the alumni network showcase. We talk about the graphics, new features and the current state of the gameplay. We also discuss the problems we were currently working to overcome.",
    dateStamp: "2nd Nov 2020",
  },
  {
    videoLink: "https://www.youtube.com/embed/YUwMSJf6xoA",
    title: "Alumni Network Showcase",
    description:
      "This video was created to give our class and some Alumni from KTH an overview of our progress and our vision going forward. Here we have got the tangibles working and are able to show a basic version of what the final game will look like. ",
    dateStamp: "6th Oct 2020",
  },
  {
    videoLink: "https://www.youtube.com/embed/KB68fMkjceo",
    title: "Second Agile Meeting",
    description:
      "Once again we discuss the feedback we recieved during the previous meeting and how we will use it. We also discuss our progress in finding a theme for the game as well as early encountered challenges in creating the physical tangibles. In the end we show a small demo of a tablet based game we created where touch was the input modlity.",
    dateStamp: "28th Sept 2020",
  },
  {
    videoLink: "https://www.youtube.com/embed/KwS_F7pSl7A",
    title: "First Agile Meeting",
    description:
      "In this video we discuss the feedback we got from our peers and how we were to apply it in our project. The feedback mostly regarded our project structure as the game itself wasn't really existing at this point.",
    dateStamp: "22nd Sept 2020",
  },
  {
    videoLink: "https://www.youtube.com/embed/PeXPvqq4t-0",
    title: "First Project Proposal",
    description:
      "This was our first presentational video of our project. Here we discuss things such as our vision, motivation, goals, potential challenges, previous work and intended use of technology. Some aspects of our vision got changed during the progress and some remained throughout!",
    dateStamp: "15th Sept 2020",
  },
];

const Home = ({
  expanded,
  setExpanded,
  showVideo,
  showGameDesc,
  showTangDesc,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "stretch",
          width: "90%",
          padding: "10px",
          justifyContent: "center",
        }}
      >
        <TangibleDescription
          expanded={expanded === "Tangible"}
          setExpanded={setExpanded}
          showTangDesc={showTangDesc}
        />
        <VideoPresentation
          expanded={expanded === "Video"}
          setExpanded={setExpanded}
          showVideo={showVideo}
          videos={videos}
        />

        <GameDescription
          expanded={expanded === "Game"}
          setExpanded={setExpanded}
          showGameDesc={showGameDesc}
        />
      </div>
    </div>
  );
};

export default Home;
